import { getAwardsSummary } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

export const AWARDS_SUMMARY_QK = 'AWARDS_SUMMARY_QUERY_KEY'

export const useAwardsSummary = (memberId?: string) => {
  const { data: awardsSummary } = useQuery({
    queryKey: [AWARDS_SUMMARY_QK, memberId],
    queryFn: () => getAwardsSummary(memberId),
    staleTime: 15 * 60 * 1000,
  })

  return { awardsSummary }
}
